import React from "react";
import styled from "styled-components";
import LineIcon from "images/custom/LineBTN-round-default.svg";

const LineContainer = styled.div`
  position: fixed;
  bottom: 10px;
  right: 0px;
  z-index: 11;
  cursor: pointer;
`;

const LineImg = styled.img`
  svg {
    width: 60px;
    height: 60px;
    border-radius: 30px;
    box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.2), 0px 1px 18px rgba(0, 0, 0, 0.12),
      0px 6px 10px rgba(0, 0, 0, 0.14);
  }
`;

const LineBtn = () => (
  <LineContainer>
    <a href="//line.me/R/ti/p/%40345pbmgy" target="blank">
      <LineImg alt="" src={LineIcon} />
    </a>
  </LineContainer>
);

export default LineBtn;
